module.exports = __webpack_public_path__ + "img/2014-4.91adde9b.jpg";